import styled from 'styled-components'

const OrderSummaryUi = styled.div``

export default OrderSummaryUi
